import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';

type HowItWorksPageProps = {
  toggleNextPage: () => void;
};

class HowItWorksPage extends React.Component<HowItWorksPageProps> {
  render(): React.ReactNode {
    return (
      <>
        <Text type="h3">How rent updates work</Text>
        <SpacerRow>
          <Text>We notify your tenant about the new rent amount.</Text>
        </SpacerRow>
        <SpacerRow>
          <Text>
            Your tenant must then accept the change for it to take effect. If your tenant takes no action, they will
            continue to pay the same amount.
          </Text>
        </SpacerRow>
        <SpacerRow size="md">
          <Button type="primary" full onClick={this.props.toggleNextPage}>
            OK, got it
          </Button>
        </SpacerRow>
      </>
    );
  }
}

export default HowItWorksPage;
